export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9388.bbbe0a0b.jpg";